module.exports = __webpack_public_path__ + "static/media/SupportCenter.ab27a420.svg";